import Rete from 'rete'
import { nanoid } from 'nanoid/async'
import { App } from '../../App'
import CONST_SOCKET from '../../const/socket'
import { otnSingleModal } from './otnSingleModal'
import {
  removeNodes,
  updateNodeConnections,
  addNewSequenceToEditor,
  addNewSequenceSingleToEditor,  
  fixYPositionOfChildComponents,
} from '../../utils/functions'

// eslint-disable-next-line
export default async (node, editor) => {
  const oldData = node.data

  const { 
    value: otnSingleData,
    isConfirmed: isClickedOkButton, 
  } = await otnSingleModal(oldData, node)

  if (otnSingleData && Object.values(otnSingleData).length > 0) {

    if (! ('newPostbackId' in node.data)) {
      node.data.title = otnSingleData.title
      node.data.newPostbackId = await nanoid(15)
    }

    Object.assign(node.data, otnSingleData)

    if ('newSequence' === otnSingleData.sequenceIdValue) {
      if (node.outputs instanceof Map) {
        const otnSingleOutputSequence = node.outputs.get(CONST_SOCKET.OTN_SINGLE_OUTPUT_SEQUENCE)
        if (otnSingleOutputSequence instanceof Rete.Output) {
          if (0 === otnSingleOutputSequence.connections.length) {
            attachNewSequenceAndChildrenToOtnSingleNode(node)
          }
        }
      }
    }

    if ('newSequence' !== otnSingleData.sequenceIdValue) {
      if (isClickedOkButton && node.otnSingleNodeNewSequenceValueChangeStatus) {
        if (node.otnSingleNodeChildrenComponents 
          && node.otnSingleNodeChildrenComponents instanceof Map
        ) {
          const nodesList = node.otnSingleNodeChildrenComponents.get('node-id-' + node.id)
          
          if (nodesList) {
            removeNodes(nodesList)
            node.otnSingleNodeChildrenComponents.delete('node-id-' + node.id)
          }
        }
      }
    }

    node.update()
    updateNodeConnections(node)
  }

  return false
}

const attachNewSequenceAndChildrenToOtnSingleNode = async (node) => {
  const newSequenceNodePosition = [node.position[0] + 320, node.position[1] + 40]
  const newSequenceNode = await addNewSequenceToEditor(newSequenceNodePosition)

  const nodeList = [newSequenceNode]

  App.editor.connect(
    node.outputs.get(CONST_SOCKET.OTN_SINGLE_OUTPUT_SEQUENCE),
    newSequenceNode.inputs.get(CONST_SOCKET.SEQUENCE_INPUT)
  )

  const items = [1, 2, 3]
  
  // eslint-disable-next-line
  items.map(async (item, index) => { 
    const sequenceSingleNodePositionY = fixYPositionOfChildComponents(index, 120, items.length)
    const squenceSingleNodePosition = [node.position[0] + 650, sequenceSingleNodePositionY]
    const sequenceSingleNode = await addNewSequenceSingleToEditor(squenceSingleNodePosition)

    nodeList.push(sequenceSingleNode)

    App.editor.connect(
      newSequenceNode.outputs.get(CONST_SOCKET.SEQUENCE_OUTPUT),
      sequenceSingleNode.inputs.get(CONST_SOCKET.SEQUENCE_SINGLE_INPUT)
    )

  })

  const componentsMap = new Map()
  componentsMap.set('node-id-' + node.id, nodeList)
  node.otnSingleNodeChildrenComponents = componentsMap
}